import Swiper from 'swiper/bundle';

const setupSwiper = (id, options) => {
    const checkDOM = document.getElementById(id);
    if (checkDOM) {
        return new Swiper('#' + id, options);
    }
};

export default setupSwiper;
